module.exports = __webpack_public_path__ + "static/media/2.999b2c4d.png";